import { LocalAudioTrack } from 'twilio-video';
import { useCallback } from 'react';
import useIsTrackEnabled from '../useIsTrackEnabled/useIsTrackEnabled';
import useVideoContext from '../useVideoContext/useVideoContext';
import useChatContext from '../../hooks/useChatContext/useChatContext';
import { useEffect } from 'react';

export default function useLocalAudioToggle() {
  const { localTracks } = useVideoContext();
  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;
  const isEnabled = useIsTrackEnabled(audioTrack);
  const { isChatWindowOpen, messages, conversation } = useChatContext();
  //console.log(messages);
  // useEffect(() => {
  //   if (messages[messages.length - 1]?.body == 'PA9f67b9567ad51197787909bcff3359e0') {
  //     if (audioTrack) {
  //       //console.log(audioTrack.isEnabled);
  //       audioTrack.disable();
  //     }
  //   }
  //   // //console.log(messages[0].body)
  // }, [messages]);

  const toggleAudioEnabled = useCallback(() => {
    // if (messages[messages.length - 1].body == "PA9f67b9567ad51197787909bcff3359e0") {
    //   if (audioTrack) {

    //     audioTrack.disable();
    //   }
    // }
    //console.log(audioTrack, 'localaudiotogglessds');
    if (audioTrack) {
      //console.log(audioTrack.isEnabled);
      audioTrack.isEnabled ? audioTrack.disable() : audioTrack.enable();
    }
  }, [audioTrack]);

  return [isEnabled, toggleAudioEnabled] as const;
}
